var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"menu"}},[_c('el-button-group',_vm._l((_vm.items),function(item){return _c('el-button',{key:item,attrs:{"type":"primary"},on:{"click":function($event){_vm.btnClickEvt(item, $event)}}},[_vm._v(_vm._s(item))])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.6.1@vue-loader/lib/template-compiler?{"id":"data-v-7f9f7544","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.6.1@vue-loader/lib/selector.js?type=template&index=0!./src/components/menu.vue
// module id = XEby
// module chunks = 1